export default "<p-blockUI [blocked]=\"Blocked\" [autoZIndex]=\"true\" [baseZIndex]=\"11000\" >\n\t<i class=\"initloader\"></i>\n</p-blockUI>"